import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ApiModule } from '@api';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

import { FormDirective, ValidateModule } from 'pn-core-code';

@NgModule({
  declarations: [],
  imports: [
    TranslatePipe,
    TranslateDirective,
    FormDirective,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ValidateModule,
    ApiModule,
    TranslatePipe,
    TranslateDirective,
    FormDirective
  ]
})
export class DefaultModule { }
